import {createContext} from 'react';

export interface userData {
   userId: number,
   email: string,
   firstName: string,
   lastName: string,
   active: boolean,
   permissions: string,
   permissionName: string
}

export interface userDataContextType {
    data: userData,
    setUserData: (filter: userData)=> void,
}

const UserContext = createContext<userDataContextType>({
    data: {userId: 0, email: '', active: false, firstName: '', lastName: '',
        permissions: '', permissionName: ''},
    setUserData: ()=> undefined,
});

export {UserContext};

